import type { Airflow } from '@aviata/platform-types';

import type { amplitudeEventsConfigTypes } from '@/shared/config';

import { extractSearchFormData } from './main-page';
import type { PartnerFilter } from './search-page';

export type ExtractSearchFormDataParams = ReturnType<
  typeof extractSearchFormData
>;

export type PrepareSearchAnalyticsParams = {
  success: boolean;
  offers?: Airflow.Offer.Entity[];
  searchStartTime: number;
  hasFilter: boolean;
  filterParams: Record<string, unknown>;
  partnerFilter?: PartnerFilter;
  segmentFilter?: boolean;
  calendarFilter: boolean;
  source: amplitudeEventsConfigTypes.SERPOpenSource;
  searchParams: {
    dep?: string;
    arr?: string;
    itineraries: Array<{ date: string; dep?: string; arr?: string }>;
    passengers: {
      adt?: number;
      yth?: number;
      chd?: number;
    };
    cabinClass?: string;
  };
  dict?: Record<string, unknown>;
  error?: string;
};

export type OfferDetailsOpenLabel =
  | 'recommended'
  | 'cheapest'
  | 'fastest'
  | 'cheapestfastest';

export type { SegmentsDataResult } from './segments';
